import { CurrencyField, PercentageField, WorkTimeField } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { useMemo } from "react"
import { Controller, useFormContext } from "react-hook-form"
import { errorHandling } from "@tm/utils"
import { ValueLabelStack } from "../../../../../ValueLabelStack"

const MAX_POSSIBLE_NUMBER = 99999.99
type Props = {
    defaultCurrencyCode?: string
    repairTimeDivision: number
}
export function HourlyRateFields({ defaultCurrencyCode, repairTimeDivision }: Props) {
    const { translateText, formatNumber } = useLocalization()
    const { control, watch } = useFormContext()

    const surcharge = Number(watch("surcharge") ?? 0)
    const hourlyRate = Number(watch("hourlyRate") ?? 0)
    const time = Number(watch("time") ?? 0)

    const pirce = useMemo(() => {
        const rate = (hourlyRate ?? 0) + (hourlyRate ?? 0) * ((surcharge || 0) / 100)
        const newPrice = (rate * (time || 0)) / (repairTimeDivision > 0 ? repairTimeDivision : 1)
        return newPrice
    }, [hourlyRate, repairTimeDivision, surcharge, time])

    return (
        <>
            <Controller
                control={control}
                name="surcharge"
                render={({ field, fieldState }) => (
                    <PercentageField
                        label={`${translateText(12475)} %`}
                        max={9999}
                        size="extralarge"
                        sx={{ width: "105px" }}
                        {...field}
                        {...errorHandling(fieldState)}
                    />
                )}
            />
            <Controller
                control={control}
                name="hourlyRate"
                render={({ field, fieldState }) => (
                    <CurrencyField
                        required
                        label={`${translateText(63)} ${defaultCurrencyCode}`}
                        max={MAX_POSSIBLE_NUMBER}
                        size="extralarge"
                        sx={{ width: "140px" }}
                        {...field}
                        {...errorHandling(fieldState)}
                    />
                )}
            />
            <Controller
                control={control}
                name="time"
                render={({ field, fieldState }) => (
                    <WorkTimeField
                        required
                        label={translateText(84)}
                        max={MAX_POSSIBLE_NUMBER}
                        size="extralarge"
                        sx={{ width: "140px" }}
                        {...field}
                        {...errorHandling(fieldState)}
                    />
                )}
            />
            <ValueLabelStack label={`${translateText(57)} ${defaultCurrencyCode}`} value={formatNumber(pirce, 2)} />
        </>
    )
}
